import { selectCustomerIsServiceProvider, selectHomebotNetworkEnabled } from '../store/selectors/customerProfile'

import { useSelector } from 'react-redux'

export const useCanViewHbnTeamPage = () => {
  const hasHomebotNetworkAccess = useSelector(selectHomebotNetworkEnabled)
  const isServiceProvider = useSelector(selectCustomerIsServiceProvider)

  return hasHomebotNetworkAccess && !isServiceProvider
}
